import React from "react";
import { useParams } from "react-router-dom";
import { ForumOutlined } from "@material-ui/icons";
import TicketsManager from "../../components/TicketsManager";
import Ticket from "../../components/Ticket";
import { messengerText as text } from "../../translate/messenger";

export default function Chat() {
  const { ticketId } = useParams();
  return (
    <div className="tw-flex tw-min-h-0 tw-min-w-0 tw-flex-1 tw-overflow-hidden">
      <section aria-label={text("conversations")} className={`${ticketId ? "tw-hidden md:tw-flex" : "tw-flex"} tw-w-full tw-shrink-0 tw-flex-col tw-border-0 tw-border-r tw-border-solid tw-border-slate-200 md:tw-w-[330px] lg:tw-w-[370px] dark:tw-border-slate-700`}>
        <TicketsManager />
      </section>
      <section className={`${ticketId ? "tw-flex" : "tw-hidden md:tw-flex"} tw-min-h-0 tw-min-w-0 tw-flex-1 tw-flex-col`}>
        {ticketId ? <Ticket key={ticketId} /> : <div className="tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-bg-[#f4f7f5] tw-p-8 tw-text-center dark:tw-bg-[#0f1c16]">
          <ForumOutlined className="tw-h-16 tw-w-16 tw-text-messenger-green" />
          <h2 className="tw-m-0 tw-text-2xl tw-font-normal">{text("welcome")}</h2>
          <p className="tw-m-0 tw-text-slate-500 dark:tw-text-slate-400">{text("welcomeHint")}</p>
        </div>}
      </section>
    </div>
  );
}
